export const PANCHANG_TYPE_OPTIONS = [
  { value: "hindu", label: "Hindu" },
  { value: "jain", label: "Jain" },
] as const;

export type PanchangType = (typeof PANCHANG_TYPE_OPTIONS)[number]["value"];

export const JAIN_MONTH_OPTIONS = [
  { value: "kartak", label: "Kartak" },
  { value: "magshar", label: "Magshar" },
  { value: "posh", label: "Posh" },
  { value: "maha", label: "Maha" },
  { value: "fagan", label: "Fagan" },
  { value: "chaitra", label: "Chaitra" },
  { value: "vaishakh", label: "Vaishakh" },
  { value: "jeth", label: "Jeth" },
  { value: "ashadh", label: "Ashadh" },
  { value: "shravan", label: "Shravan" },
  { value: "bhadarvo", label: "Bhadarvo" },
  { value: "aaso", label: "Aaso" },
] as const;

export const PAKSHA_OPTIONS = [
  { value: "sud", label: "Sud" },
  { value: "vad", label: "Vad" },
] as const;

export const JAIN_TITHI_OPTIONS = [
  { value: "padvo", label: "Padvo (Pratipada)" },
  { value: "bij", label: "Bij" },
  { value: "trij", label: "Trij" },
  { value: "choth", label: "Choth" },
  { value: "pancham", label: "Pancham" },
  { value: "chhath", label: "Chhath" },
  { value: "satam", label: "Satam" },
  { value: "aatham", label: "Aatham" },
  { value: "nom", label: "Nom" },
  { value: "dasham", label: "Dasham" },
  { value: "agiyaras", label: "Agiyaras" },
  { value: "baras", label: "Baras" },
  { value: "teras", label: "Teras" },
  { value: "chaudas", label: "Chaudas" },
  { value: "poonam", label: "Poonam" },
  { value: "amavasya", label: "Amavasya" },
] as const;

export interface JainPanchang {
  id: number;
  english_date: string;
  day_of_week?: string | null;
  type: PanchangType;
  jain_month: string;
  paksha: string;
  jain_tithi: string;
  festival?: number | null;
  festival_name?: string | null;
  religious_occasion?: string | null;
  show_on_website: boolean;
  is_important: boolean;
  highlight_in_calendar: boolean;
  show_in_upcoming: boolean;
  display_order: number;
  status: boolean;
  short_description?: string | null;
  significance?: string | null;
  recommended_activities?: string | null;
  donation_message?: string | null;
  created_at?: string;
  updated_at?: string;
}

export type JainPanchangPayload = Pick<
  JainPanchang,
  | "english_date"
  | "type"
  | "jain_month"
  | "paksha"
  | "jain_tithi"
  | "festival"
  | "religious_occasion"
  | "show_on_website"
  | "is_important"
  | "highlight_in_calendar"
  | "show_in_upcoming"
  | "display_order"
  | "status"
  | "short_description"
  | "significance"
  | "recommended_activities"
  | "donation_message"
>;
